
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanXShape as ObiBuoyCanXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-x-shape.js';
 
 
 

 
 export const ObiBuoyCanXShape = createComponent({
   react: React,
   tagName: 'obi-buoy-can-x-shape',
   elementClass: ObiBuoyCanXShapeElement,
   events: {
     
   }
  });
 
 